module.exports = __webpack_public_path__ + "static/media/logo.c56483ef.png";